import { render, staticRenderFns } from "./VueMenuList.vue?vue&type=template&id=627f68aa&scoped=true&"
import script from "./VueMenuList.vue?vue&type=script&lang=js&"
export * from "./VueMenuList.vue?vue&type=script&lang=js&"
import style0 from "./VueMenuList.vue?vue&type=style&index=0&id=627f68aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627f68aa",
  null
  
)

export default component.exports